import Hero from "../components/Hero";
import PrevAbout from "../components/PrevAbout";
// import PrevServices from "../components/PrevServices";
import Reviews from "../components/Reviews";
import CarouselRooms from "../components/CarouselRooms";
import { useGlobalContext } from "../context";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useMediaQuery } from "react-responsive";
import { useTranslation } from "react-i18next";
import PrevPool from "../components/PrevPool";



const Home = () => {
  const {t} = useTranslation();
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const {rooms, setRooms} = useGlobalContext();
  const firstThreeWithImages = rooms.filter(room => room.images).slice(0, 3);

  return (<>
    <Hero />
    <div style={{position: 'relative'}}>
      <PrevAbout />
    <div style={{backgroundColor: 'var(--gray)', padding: '50px 0px'}}>
      <HeaderTitle className="container" style={isMobile ? {flexDirection: 'column', justifyContent: 'flex-end'} : {alignItems: 'flex-end'}}>
          <div>
            <div className="title">{t('camere2')}</div>
            <p>{t('scopriCamere')}</p>
          </div>
          <div className="btn" style={isMobile ? {marginTop: '9px'} : {}} >
            <Link className='link' to='/rooms'>
              {t('vediCamere')}
            </Link>
          </div>
        </HeaderTitle>
        <CarouselRooms rooms={firstThreeWithImages} setRooms={setRooms} />      
    </div>
    <PrevPool />
      {/* <PrevServices /> */}
      <Reviews />
    </div>
  </>
  );
}

export default Home

const HeaderTitle = styled.div`
  display: flex;
  justify-content: space-between;
  /* align-items: flex-end; */
  /* flex-direction: column; */
  padding: 10px;
  .title {
    color: var(--logo);
    text-transform: uppercase;
    font-size: 25px;
    font-weight: bold;
    border-bottom: 2px solid var(--logo);
    display: inline-block;
    padding-right: 3px;
    margin-bottom: 9px;
  } 
    .link {
    color: white;
    font-weight: lighter;
    font-size: 12px;
    padding: 3px 9px;
    border-radius: 5px;
    text-transform: uppercase;
    background-color: var(--footer);
  }
  .icon {
    border: 1px solid white;
  }
`